
<!-- Google tag (gtag.js) -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-FMSCKCLYDG"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-FMSCKCLYDG');
</script>

<template>
  <div class="bg-lighter full-view">
    <b-container fluid>
      <b-row>
        <b-col offset-md="1" sm="12" md="11">
          <h1 class="mb-2 mt-5">About us</h1>
        </b-col>
        <b-col offset-md="1" sm="12" md="10">
          <p class="mb-2 mt-5 text-justify">
            The mission of the Danish Covid-19 Genome Consortium (DCGC) is to
            assist public health authorities to monitor the spread of
            SARS-CoV-2. The project was established in March 2020 through the
            coordinated effort of Aalborg University, Statens Serum Institute,
            Hvidovre Hospital, and Aalborg University Hospital. Large-scale
            SARS-CoV-2 sequencing capacity was initially established at Aalborg
            University and local sequencing capacity at Statens Serum Institute
            and Hvidovre Hospital. Since June, the consortium has established
            additional local sequencing nodes at Aalborg University Hospital,
            Aarhus University Hospital, Slagelse Hospital, Rigshospitalet,
            Sygehus Lillebælt, and Odense University Hospital.
          </p>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col offset-md="1" sm="12" md="10">
          <b-row>
            <b-col sm="12" md="3">
              <p>
                <h3>AAU</h3>
              <p>
                <strong>AAU Coordination</strong><br />
                Mads Albertsen (initiator)
              </p>
              <p>
                <strong>AAU Laboratory</strong><br />
                Jakob Brandt (team leader)<br />
                Simon Knuttson<br />
                Emil A. Sørensen<br />
                Thomas B. N. Jensen<br />
                Trine Sørensen<br />
                Celine Petersen<br />
                Clarisse Chiche-Lapierre<br />
                Frederik T. Hansen<br />
                Emilio F. Collados<br />
                Amalie Berg<br />
                Susanne R. Bielidt<br />
                Sebastian M. Dall<br />
                Erika Dvarionaite<br />
                Susan H. Hansen<br />
                Vibeke R. Jørgensen<br />
                Trine B. Nicolajsen<br />
                Wagma Saei<br />
                Stine K. Østergaard                
              </p>
              <p>
                <strong>AAU Bioinformatics</strong><br />
                Thomas Y. Michaelsen (team leader)<br />
                Vang Le-Quy<br />
                Mantas Sereika<br />
                Rasmus H. Kirkegaard<br />
                Kasper S. Andersen<br />
                Martin H. Andersen
              </p>
              <p>
                <strong>AAU CLAUDIA / IT</strong><br />
                Karsten K. Hansen<br />
                Mads Boye<br />
                Mads P. Bach<br />
                Peter Dissing<br />
                Anton Drastrup-Fjordbak<br />
                Michael Collin<br />
                Finn Büttner
              </p>
              <p>
                <strong>AAU Legal and Admin</strong><br />
                Susanne Andersen<br />
                Lea Sass Otte
              </p>
              <p>
                <strong>AAU SUND</strong><br />
                Martin Bøgsted<br />
                Rasmus Brøndum
              </p>
              <p>
                <strong>AAU Computer Science</strong><br />
                Katja Hose<br />
                Tomer Sagi<br />
                Miroslav Pakanec
              </p>
            </b-col>
            <b-col sm="12" md="3">
              <p>
                <h3>Statens Serum Institute</h3>
              <p>
                Anders Fomsgaard (initiator)<br />
                Morten Rasmussen<br />
                Søren M. Karst<br />
                Jannik Fonager<br />
                Vithiagaran Gunalan<br />
		Marc Bennedbæk<br />
		Aleksander Ring<br />
		Raphael Sieber<br />
		Kirsten Ellegaard<br />
                Anna C. Ingham<br />
                Thor B. Johannesen<br />
                Gitte Nygaard Aasbjerg<br />
                Berit Lilje<br />
                Kim L. Ng<br />
                Sofie M. Edslev<br />
                Sharmin Baig<br />
                Marc Stegger<br />
		Povilas Matusevicius<br />
		Lars Bustamante Christoffersen<br />
		Man-Hung Eric Tang<br />
		Leandro Andrés Escobar-Herrera<br />
		Casper Westergaard<br />
		Christina Wiid Svarrer<br />
		Nour Saad Al-Tamimi<br />
		Marie Bækvad-Hansen<br />
		Jonas Byberg-Grauholm<br />
		Mette Theilgaard Christiansen<br />
		Karen Marie Jørgensen (TestCenter Denmark)<br />
		Tobias Nikolaj Gress Hansen (TestCenter Denmark)<br />
                Esben Mørk Hartmann (TestCenter Denmark) <br />
		Nicolai Balle Larsen (TestCenter Denmark)<br />
		Arieh Cohen (TestCenter Denmark)<br />
		Kasper Holtz Uhre (Danish National Biobank)<br />
		Christian Nielsen (Danish National Biobank)<br />
		Anders Jensen (Danish National Biobank)<br />
		Jakob Matias Melbye (Danish National Biobank)<br />
		Bartlomiej Wilkowski (Danish National Biobank)<br />
		Karina Meden Sørensen (Danish National Biobank)<br />
                (+ Lab technicians)
              </p>
            </b-col>
            <b-col sm="12" md="3">
              <p>
                <h3>Hospitals</h3>
              <p>
                <strong>Aalborg University Hospital</strong><br />
                Henrik Krarup (initiator)<br />
                David Fuglsang-Damgaard<br />
                Mette Mølvadgaard<br />
                Marc T. K. Nielsen
              </p>
              <p>
                <strong>Rigshospitalet</strong><br />
                Kristian Schønning (initiator)<br />
                Martin S. Pedersen<br />
                Rasmus L. Marvig<br />
                Nikolai Kirkby
              </p>
              <p>
                <strong>Hvidovre Hospital</strong><br />
		Uffe V. Schneider<br />
                Jose A. S. Castruita<br />
                Nana G. Jacobsen<br />
                Christian Ø. Andersen
              </p>
              <p>
                <strong>Aarhus University Hospital </strong><br />
		Mette Christiansen<br />
		Ole H. Larsen<br />
		Kristian A. Skipper<br />
		Søren Vang<br />
                Kurt J. Handberg<br />
		Carl M. Kobel<br />
		Camilla Andersen<br />
		Irene H. Tarpgaard<br />
		Svend Ellermann-Eriksen
              </p>
              <p>
                <strong>Odense University Hospital</strong><br />
                Marianne Skov<br />
		Thomas V. Sydenham
              </p>
              <p>
		<strong>Herlev Hospital</strong><br />
		Lene Nielsen<br />
		Line L. Nilsson<br />
		Martin B. Friis<br />
		Thomas Sundelin<br />
		Thomas A. Hansen
              </p>
              <p>                                                                                                                                                                                                                                  <p>
		<strong>Sydvestjysk Sygehus</strong><br />
		Dorte T. Andersen<br />
		John E. Coia<br />
              </p>
              <p>
                <strong>Sygehus Lillebælt </strong><br />
                Anders Jensen<br />
		Ea S. Marmolin
              </p>
              <p>
		<strong>Zealand University Hospital</strong><br />
		Xiaohui C. Nielsen<br />
		Christian H. Schouw
              </p>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col sm="12">
              <h3>Funding</h3>
              <p>
                The project is funded by the
                <b-link
                  target="_blank"
                  href="https://www.pdjf.dk/nyheders/fra-microflora-danica-til-corona-danica/"
                  >Poul Due Jensen foundation</b-link
                >
                (Grundfos foundation) and
                <b-link
                  target="_blank"
                  href="https://ufm.dk/forskning-og-innovation/COVID-19-forskning/danske-covid-19-relaterede-forsknings-og-innovationsinitiativer/coronarelaterede-forskningsprojekter"
                >
                  Uddannelses- og Forskningsministeriet</b-link
                >. The project has now moved to the production phase and is
                funded through SSI as part of the SARS-CoV-2 surveillance in
                Denmark.
              </p>
            </b-col>
          </b-row>
          <b-row align-v="center" class="mt-3 mb-5">
            <b-col sm="8" md="5">
              <a
                href="https://www.pdjf.dk/nyheders/fra-microflora-danica-til-corona-danica/"
                target="_blank"
              >
                <b-img
                  src="../../public/logo1.svg"
                  fluid
                  alt="Poul Due Jensen foundation"
                ></b-img>
              </a>
            </b-col>
            <b-col sm="12" md="5" offset-md="1">
              <a
                href="https://ufm.dk/forskning-og-innovation/COVID-19-forskning/danske-covid-19-relaterede-forsknings-og-innovationsinitiativer/coronarelaterede-forskningsprojekter"
                target="_blank"
              >
                <b-img
                  src="../../public/logo2.png"
                  fluid
                  alt="Uddannelses- og Forskningsministeriet"
                ></b-img>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

